export const stripePublishableKeyProd =
  'pk_live_51HzOCtAnIc3UbsjuaGNKzCiEDhWXoErBBMML7aJMaZFdwO4Vx5XTxjWHRwmfCYaxq4BaePaV9YxWu1nF5eDUdsPz00w9uJzooQ'

export const stripePublishableKeyStag =
  'pk_test_51HzOCtAnIc3Ubsju2mZYS2u0aMAiNzqHVCcpYeYlu0G3dJUrJYTEtMXtEKt7kL3uxpBcq8Tldfhnh2Jy1ZrHUdim00bpU8xFY7'
